import React from "react";
import RiAiStatisticTable from "./RiAiStatisticTable";
import GraphType from "GraphType";
import { connect } from "react-redux";

const RiPanelAiStatistics = ({ selectedSwingSize, percentile, declines, rallies, summary, majorPeriodicity }) => {
  const periodicityText = majorPeriodicity === GraphType.Daily ? "d" : majorPeriodicity === GraphType.Weekly ? "w" : "m";
  const periodicityFullText = majorPeriodicity === GraphType.Daily ? "day" : majorPeriodicity === GraphType.Weekly ? "week" : "month";
  const pluralText = percentile.duration > 1 ? "s" : "";
  const change = ((percentile.pricePercentChange || 0) * 100).toFixed(0)
  const duration = percentile.duration || 0;
  const percentileValue = percentile.percentile || 0
  function ordinal(n) {
    if (n % 100 >= 11 && n % 100 <= 13) {
        return n + "th %";
    }
    switch (n % 10) {
        case 1: return n + "st\u00A0%";
        case 2: return n + "nd\u00A0%";
        case 3: return n + "rd\u00A0%";
        default: return n + "th\u00A0%";
    }
}
  return (
    <div className="ri-panel-ai-statistics">
      {/* Header */}
      <div className="header">
        <span className="grey-txt">{selectedSwingSize}% ZIGZAG: </span>
        <span className={change >= 0 ? "positive" : "negative"}>{change}%</span>
        <span className="black-txt" > over {duration} trading {periodicityFullText}{pluralText} ({ordinal(percentileValue)})</span>
      </div>

      {/* Stats Box */}
      <div className="statistics-box">
        <RiAiStatisticTable 
          title='RALLIES'
          color='light-blue'
          data={rallies}
          count={summary.rallyCount}
          currentChange={change}
          currentDuration={duration}
          periodicityText={periodicityText}
        />
        <RiAiStatisticTable 
          title='DECLINES'
          color='negative'
          data={declines}
          count={summary.declineCount}
          currentChange={change}
          currentDuration={duration}
          periodicityText={periodicityText}
        />
      </div>
    </div>
  );
};
const mapStateToProps = ({ RelatedInfoPanelReducers, DatagraphReducers }) => {
    const { selectedSwingSize, percentile, declines, rallies, summary } = RelatedInfoPanelReducers.RiPanelAI;
    const { majorPeriodicity } = DatagraphReducers.DataGraphReducer;

    return { selectedSwingSize, percentile, declines, rallies, summary, majorPeriodicity };
};

export default connect(mapStateToProps)(RiPanelAiStatistics);
